import '/assets/styles/sections/basket-controls.scss';
import classNames from 'classnames';

// Partials
import Btn from '/views/partials/btn';
import Pricebox from '/views/partials/pricebox';
import Placeholder from '/views/partials/placeholder';

// Context
import { useBasket, useBasketProductControls } from '/controllers/basket';
import { useBranchSelection } from '/utilities/branch-selection';
import { useTranslation } from '/utilities/i18n';
import { useMemo } from 'react';

const BasketControls = ({
	className,
	product,
	disabled: rawDisabled,
	loading,
	onSubmit,
	total: totalProp,
}) => {
	const { total, busy } = useBasket();
	const {
		canIncreaseQuantity,
		canDecreaseQuantity,
		increaseQuantity,
		decreaseQuantity,
		quantity,
		canAdd: rawCanAdd,
	} = useBasketProductControls(product);
	const { checkoutEnabled } = useBranchSelection();
	const { t } = useTranslation();

	const canAdd = useMemo(() => (product ? rawCanAdd : true), [rawCanAdd, product]);
	const disabled = useMemo(() => rawDisabled || !canAdd, [rawDisabled, canAdd]);

	if (!checkoutEnabled) {
		return null;
	}

	return (
		<section className={classNames('section', 'basket-controls', className, { disabled })}>
			{!!(product && canAdd) && (
				<div className={classNames('controls-top', { show: !!quantity })}>
					<Btn
						className="top-btn yellow"
						onClick={decreaseQuantity}
						disabled={disabled || !canDecreaseQuantity || busy}
					>
						{t('Çıkar')}
					</Btn>
					<span className="top-quantity">{quantity} {t('Adet')}</span>
					<Btn
						className="top-btn yellow"
						onClick={increaseQuantity}
						disabled={disabled || !canIncreaseQuantity || busy}
					>
						{t('Ekle')}
					</Btn>
				</div>
			)}
			<div className="controls-bottom">
				<div className={classNames('bottom-total', { show: !!(quantity && canAdd) || !product })}>
					<span className="total-title">{t('Toplam:')}</span>{' '}
					{totalProp === false || busy ? (
						<Placeholder darker className="total-price" />
					) : (
						<Pricebox horizontal className="total-price" price={totalProp ?? total} />
					)}
				</div>
				<div className="bottom-ctawrap">
					{!!(canAdd && product && !quantity) && (
						<Btn
							icon="cart"
							onClick={increaseQuantity}
							className="bottom-cta big text-big block primary"
							disabled={disabled || !canIncreaseQuantity || busy}
						>
							{t('Sepete Ekle')}
						</Btn>
					)}

					{!canAdd && (
						<div className="bottom-message">{t('Bu ürünü şu an sepetine ekleyemezsin.')}</div>
					)}

					{!!(product && quantity) && (
						<Btn
							tag="link"
							href="basket"
							icon="cart"
							disabled={busy}
							className="bottom-cta big text-big block primary"
						>
							{t('Sepete Git')}
						</Btn>
					)}
					{!product && (
						<Btn
							onClick={onSubmit}
							type="submit"
							disabled={loading || disabled}
							loading={loading}
							className="bottom-cta big text-big block primary"
						>
							{t('Devam Et')}
						</Btn>
					)}
				</div>
			</div>
		</section>
	);
};

export default BasketControls;
